module.exports = __webpack_public_path__ + "img/xcx.4ac82f0c.jpg";